
import React from 'react';
import { Textarea } from '@/components/ui/textarea';

interface JSONEditorProps {
  value: any;
  onChange: (value: any) => void;
  height?: string;
}

const JSONEditor: React.FC<JSONEditorProps> = ({ value, onChange, height = '200px' }) => {
  // Convert the JSON object to a formatted string
  const formattedValue = React.useMemo(() => {
    try {
      return JSON.stringify(value, null, 2);
    } catch (error) {
      console.error('Error formatting JSON:', error);
      return '{}';
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    try {
      const parsedValue = JSON.parse(e.target.value);
      onChange(parsedValue);
    } catch (error) {
      // If the JSON is invalid, we still update the textarea but don't call onChange
      console.error('Invalid JSON:', error);
    }
  };

  return (
    <Textarea
      value={formattedValue}
      onChange={handleChange}
      className="font-mono text-sm"
      style={{ height, resize: 'vertical' }}
    />
  );
};

export default JSONEditor;
